import { Component} from '@angular/core';
 
@Component({
    selector: 'app-contribuicao',
    templateUrl: './contribuicao.component.html',
    styleUrls: ['./contribuicao.component.scss']
})


export class contribuicaoComponent {}